import { Chip } from "@/components/core/Chip";
import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

import { ContentCard } from "../ContentCard";
import { ContentCardScaffold } from "./ContentCardScaffold";

export const HorizontalCard = ({
    content,
    ...props
}: Omit<ComponentProps<typeof ContentCard>, "type" | "content"> & {
    content: Mix_ContentFragment;
}) => {
    const { onClick, ...scaffoldProps } = props;
    return (
        <ContentCardScaffold {...scaffoldProps}>
            <div className="flex items-center">
                <ContentCardScaffold.SourceAuthorHeader
                    className="w-full"
                    sourceImgSize={32}
                    sourceImgUrl={content.mix_source_info.imgurl}
                    authorname={content.authorname}
                    updatetime={content.updatetime}
                    offlinetime={content.offlinetime}
                    category={content.category}
                />
                <ContentCardScaffold.Bookmark
                    variant="icon"
                    content={content}
                />
            </div>
            <div className="mb-[10px] mt-[14px] flex gap-3">
                <div className="flex flex-1 flex-col gap-1">
                    <ContentCardScaffold.Title>
                        {content.title}
                    </ContentCardScaffold.Title>
                    <ContentCardScaffold.Abstract>
                        {content.abstractcontents}
                    </ContentCardScaffold.Abstract>
                </div>
                <ContentCardScaffold.ThumbnailImg
                    className="h-[70px] rounded-md"
                    src={content.imgurl ?? ""}
                    width={70}
                    height={70}
                    loader={({ src }) => src + "?w=210"}
                />
            </div>
            <div className="flex items-center justify-between">
                <ContentCardScaffold.Tags tags={content.mix_content_tags} />
                {content.category && <Chip className="dark:bg-gray-500">{content.category}</Chip>}
            </div>
        </ContentCardScaffold>
    );
};
